export class SearchResult<ListType> {
    totalItems: Number;
    listItems: Array<ListType>;

    constructor(){
        this.totalItems = 0;
        this.listItems = new Array<ListType>();
    }
}


// WEBPACK FOOTER //
// ./src/app/models/utils/SearchResult.model.ts